import { axios } from '../../../lib/core/AxiosInterceptor/AxiosInterceptor';
import { mapToCamelCase } from '../../../lib/helpers/helpers';
import { useQuery } from '@tanstack/react-query';
import { APIHelpSections } from '@partnerconnect-monorepo/types/HelpSection';

export const GET_HELP_SECTIONS_LIST_QUERY_KEY = 'HELP_SECTIONS';

const getHelpSections = () =>
  axios
    .get('/help-sections/')
    .then<APIHelpSections>((res) => mapToCamelCase(res.data));

export const useHelpSections = () =>
  useQuery({
    queryKey: [GET_HELP_SECTIONS_LIST_QUERY_KEY],
    queryFn: getHelpSections
  });
